import { MARK_HOME_FOR_UNSUBSCRIBE } from 'src/actions/actionTypes'

export const markHomeForUnsubscribe = () => ({
  type: MARK_HOME_FOR_UNSUBSCRIBE
})
